import types from './types';
import api from "../api";
import {createError, logError, logSuccess} from "./message";
import {getMasterClassFull, getMasterClassCard, getMasterClassStudents} from "./actions";

function requestMasterClassDelete() {
  return {
    type: types.DELETE_MASTER_CLASS_REQUEST,
    isDeletingMasterClass: true
  };
}

function requestMasterClassDeleteCompleted(deletedMasterClass) {
  return {
    type: types.UPDATE_MASTER_CLASS_COMPLETED,
    isDeletingMasterClass: false,
    deletedMasterClass
  };
}

function requestMasterClassDeleteError(masterClassDeleteError) {
  return {
    type: types.UPDATE_MASTER_CLASS_ERROR,
    isDeletingMasterClass: false,
    masterClassDeleteError
  };
}

export function deleteMasterClass(id) {
  return dispatch => {
    dispatch(requestMasterClassDelete());
    return api.deleteMasterClass(id)
      .then(response => {
        if (response.status === 200) {
          let resp = response.data;
          dispatch(requestMasterClassDeleteCompleted(resp));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(requestMasterClassDeleteError(message));
        } else {
          logError(err);
          dispatch(requestMasterClassDeleteError(createError("Не удалось удалить выбранный мастер класс")));
        }
      });
  };
}

//delete Logo
function requestMasterClassLogoDelete() {
  return {
    type: types.DELETE_MASTER_CLASS_LOGO_REQUEST,
    isDeletingLogo: true
  };
}

function requestMasterClassLogoDeleteCompleted(deletedLogo) {
  return {
    type: types.DELETE_MASTER_CLASS_LOGO_COMPLETED,
    isDeletingLogo: false,
    deletedLogo
  };
}

function requestMasterClassLogoDeleteError(logoDeleteError) {
  return {
    type: types.DELETE_MASTER_CLASS_LOGO_ERROR,
    isDeletingLogo: false,
    logoDeleteError
  };
}

export function deleteMasterClassLogo(id) {
  return dispatch => {
    dispatch(requestMasterClassLogoDelete());
    return api.deleteLogo(id)
      .then(response => {
        if (response.status === 200) {
          let resp = response.data;
          dispatch(requestMasterClassLogoDeleteCompleted(resp));
          dispatch(getMasterClassFull(id));
          dispatch(getMasterClassCard(id));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(requestMasterClassLogoDeleteError(message));
        } else {
          logError(err);
          dispatch(requestMasterClassLogoDeleteError(createError("Не удалось обновить данные мастер класса")));
        }
      });
  };
}

//delete Document
function requestMasterClassDocumentDelete() {
  return {
    type: types.DELETE_MASTER_CLASS_FILE_REQUEST,
    isDeletingMasterClassFile: true
  };
}

function requestMasterClassDocumentDeleteCompleted(deletedMasterClassFile) {
  return {
    type: types.DELETE_MASTER_CLASS_FILE_COMPLETED,
    isDeletingMasterClassFile: false,
    deletedMasterClassFile
  };
}

function requestMasterClassDocumentDeleteError(fileDeleteError) {
  return {
    type: types.DELETE_MASTER_CLASS_FILE_ERROR,
    isDeletingMasterClassFile: false,
    fileDeleteError
  };
}

export function deleteMasterClassDocument(id) {
  return dispatch => {
    dispatch(requestMasterClassDocumentDelete());
    return api.deleteDocument(id)
      .then(response => {
        if (response.status === 200) {
          let resp = response.data;
          dispatch(requestMasterClassDocumentDeleteCompleted(resp));
          dispatch(getMasterClassFull(id));
          dispatch(getMasterClassCard(id));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(requestMasterClassDocumentDeleteError(message));
        } else {
          logError(err);
          dispatch(requestMasterClassDocumentDeleteError(createError("Не удалось обновить данные мастер класса")));
        }
      });
  };
}

function deleteStudentRequest() {
  return {
    type: types.DELETE_STUDENT_REQUEST,
    isDeletingStudent: true
  };
}

function deleteStudentCompleted(deletedStudent) {
  return {
    type: types.DELETE_STUDENT_COMPLETED,
    isDeletingStudent: false,
    deletedStudent
  };
}

function deleteStudentError(deletingStudentError) {
  return {
    type: types.DELETE_STUDENT_ERROR,
    isDeletingStudent: false,
    deletingStudentError
  };
}

export function deleteStudent(id, studentId) {
  return async (dispatch, getState) => {
    dispatch(deleteStudentRequest());
    return api.deleteStudent(id, studentId)
      .then(response => {
        if (response.status === 200) {
          dispatch(deleteStudentCompleted(response.data));
          dispatch(getMasterClassStudents(id));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({ message }) => message).join(", ");
          }
          logError(message);
          dispatch(deleteStudentError(message));
        } else {
          logError(err);
          dispatch(deleteStudentError(createError("Не удалось отправить запрос удаления обучающегося с мастер-класса")));
        }
      });
  };
};

export default {
  deleteMasterClass,
  deleteMasterClassLogo,
  deleteMasterClassDocument,
  deleteStudent
}
